import type { TrelloWindow } from '@trello/window-types';
declare const window: TrelloWindow;
import './configure-promise-queue';
import './error-test';
import './globals';
import { initialize as initSnowplowAnalytics } from '@trello/analytics';
import { initialize as initAtlassianAnalytics } from '@trello/atlassian-analytics';
import './intl-polyfill';
import './live-updater';
import './load-gapi';
import './pinocchio';
import './subscriber';
import './token-watcher';
import './vendor-patches';
import './window-resize-watcher';
import { setWebSocketsActive } from '@trello/web-sockets';

window.activateWebSockets = () => setWebSocketsActive(true);
window.deactivateWebSockets = () => setWebSocketsActive(false);

// eslint-disable-next-line @trello/no-module-logic
initSnowplowAnalytics();
// eslint-disable-next-line @trello/no-module-logic
initAtlassianAnalytics();
